import ConditionalTooltipText from "./ConditionalTooltipText";

export default ConditionalTooltipText;
